/**
 * Fetches ICE configuration from the signaling server.
 * Falls back to public Google STUN if the server is unreachable.
 *
 * @module features/p2p-chat/lib/turn
 */

interface TurnCredsResponse {
  readonly urls: readonly string[] | string;
  readonly username?: string;
  readonly credential?: string;
}

const FALLBACK: RTCConfiguration = {
  iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
};

export async function getIceConfig(
  signalHttpUrl: string
): Promise<RTCConfiguration> {
  try {
    const res = await fetch(`${signalHttpUrl}/turn-creds`, {
      cache: 'no-store',
    });
    if (!res.ok) return FALLBACK;
    const data = (await res.json()) as TurnCredsResponse;
    if (!data.urls) return FALLBACK;

    const iceServer: RTCIceServer = { urls: data.urls as string | string[] };
    if (data.username) iceServer.username = data.username;
    if (data.credential) iceServer.credential = data.credential;

    return { iceServers: [iceServer] };
  } catch {
    return FALLBACK;
  }
}
